import styled from 'styled-components';
import { Colors } from '../../styles/colors.ts';
import SvgGetter from './SVG/SvgGetter/SvgGetter.tsx';
import { FC } from 'react';
import SimpleLink from './Links/SimpleLink.tsx';
import { Spacing } from '../../styles/spacing.ts';

interface FooterProps {
	className?: string;
}

export const Footer: FC<FooterProps> = ({ className }) => {
	return (
		<FooterContainer className={className}>
			<Links>
				<StyledSimpleLink
					url='https://www.figma.com/proto/NAMVTa4EdjKv5oWzixLD3A/VegDim---Regler?page-id=0%3A1&type=design&node-id=30-25&t=04wr9EqxjhkdpYfk-1&scaling=scale-down-width&starting-point-node-id=30%3A25&mode=design'
					text='Oversikt over krav fra N200'
				/>
				<StyledSimpleLink url='https://www.vegvesen.no/vegdim' text='Les mer om FoUI-programmet' />
			</Links>
			<StyledSvgGetter icon={'SvvLogoMedTekstGjennomsiktig'} wrapSvg />
		</FooterContainer>
	);
};

const FooterContainer = styled.div`
	position: absolute;
	bottom: 0;
	width: calc(100% - 16rem);
	border-top: 1px solid ${Colors.borders.secondary};
	padding: 1.5rem 0 4rem;
	justify-content: space-between;
	display: flex;
`;

const Links = styled.div`
	display: flex;
	column-gap: 2.5rem;
	flex-wrap: wrap;
	row-gap: ${Spacing.lg};
`;

const StyledSimpleLink = styled(SimpleLink)`
	color: ${Colors.primaryTekst};
`;

const StyledSvgGetter = styled(SvgGetter)`
	width: 7.39181rem;
	height: 3.875rem;
`;
